// AnswerFlowChartDemo.js
import React from 'react';
import { motion } from 'framer-motion';

const flowcharts = {
  var1: {
    nodes: [
      {
        id: '1',
        data: { label: '📊 VaR Concept' },
        position: { x: 10, y: 10 }
      },
      {
        id: '2',
        data: { label: '📉 Measures Potential Loss' },
        position: { x: 200, y: 10 }
      },
      {
        id: '3',
        data: { label: '📈 Used for Risk Evaluation' },
        position: { x: 400, y: 10 }
      }
    ],
    edges: [
      { id: 'e1-2', source: '1', target: '2' },
      { id: 'e2-3', source: '2', target: '3' }
    ]
  },
  mapping1: {
    nodes: [
      { id: '1', data: { label: '🧭 Mapping' }, position: { x: 50, y: 10 } },
      { id: '2', data: { label: '🚀 Useful in IPOs' }, position: { x: 250, y: 10 } },
      { id: '3', data: { label: '📂 Limited Historical Data' }, position: { x: 250, y: 80 } }
    ],
    edges: [
      { id: 'e1-2', source: '1', target: '2' },
      { id: 'e1-3', source: '1', target: '3' }
    ]
  }
};

function SvgFlowChart({ flowId }) {
  const flow = flowcharts[flowId];
  if (!flow) return <p className="text-red-600">No flowchart found for ID: {flowId}</p>;

  return (
    <motion.svg
      viewBox="0 0 500 150"
      className="w-full h-[180px] mt-4 rounded-xl shadow-md bg-indigo-50 border border-indigo-100"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      {flow.edges.map((edge, idx) => {
        const source = flow.nodes.find(n => n.id === edge.source);
        const target = flow.nodes.find(n => n.id === edge.target);
        if (!source || !target) return null;
        return (
          <line
            key={idx}
            x1={source.position.x + 140}
            y1={source.position.y + 25}
            x2={target.position.x}
            y2={target.position.y + 25}
            stroke="#6366f1"
            strokeWidth="2"
            markerEnd="url(#arrow)"
          />
        );
      })}

      <defs>
        <marker id="arrow" markerWidth="10" markerHeight="10" refX="6" refY="3" orient="auto">
          <path d="M0,0 L0,6 L9,3 z" fill="#6366f1" />
        </marker>
      </defs>

      {flow.nodes.map((node, idx) => (
        <g key={idx} transform={`translate(${node.position.x}, ${node.position.y})`}>
          <rect width="160" height="45" rx="10" ry="10" fill="#ffffff" stroke="#4f46e5" strokeWidth="1.5" />
          <foreignObject x="0" y="0" width="160" height="45">
            <div xmlns="http://www.w3.org/1999/xhtml" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', fontSize: '13px', fontWeight: '500', color: '#1f2937', textAlign: 'center', padding: '0 8px' }}>
              {node.data.label}
            </div>
          </foreignObject>
        </g>
      ))}
    </motion.svg>
  );
}

export default function AnswerFlowChartDemo() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-xl font-bold text-indigo-700">Q2: Why is mapping considered useful in modern risk management?</h2>

      <p className="mt-2 font-semibold">Answer:</p>
      <p className="bg-indigo-50 p-4 rounded-md text-gray-800">
        It helps risk managers evaluate risk even when positions change over time or when historical data isn’t available—
        such as in IPOs or maturing bonds.
      </p>

      <p className="mt-2 italic text-indigo-600">💡 Hint: Focus on flexibility and limited historical data.</p>

      <SvgFlowChart flowId="mapping1" />
    </div>
  );
}